import styles from './styles.module.scss';

const Disclaimer = ({ children, className = '' }) => (
    <small className={`${styles.disclaimer} ${className}`}>{children}</small>
);

export default Disclaimer;
